module.exports = __webpack_public_path__ + "static/media/attachments.3723a415.svg";